export const get_notifications = `query get_notifications($paginator: Paginator!){
    get_notifications(paginator: $paginator){
        notifications{
            id
            time
            text
            text_en
            direction
            unread
        }
        page
        page_count
    }
}`;
